import request from '@/config/axios'

export interface MarketCategoryVO {
  id?: number
  name?: string
  alias?: string
  icon?: string
  leftIcon?: string
  leftIconColor?: string
  visible?: boolean
  sort?: number
  status?: number
  subClassifyJson?: Array<Record<string, unknown>>
}

export const getMarketCategoryList = () => request.get({ url: '/market/category/list' })
export const getMarketCategory = (id: number) =>
  request.get({ url: '/market/category/get', params: { id } })
export const createMarketCategory = (data: MarketCategoryVO) =>
  request.post({ url: '/market/category/create', data })
export const updateMarketCategory = (data: MarketCategoryVO) =>
  request.put({ url: '/market/category/update', data })
export const deleteMarketCategory = (id: number) =>
  request.delete({ url: '/market/category/delete', params: { id } })
